import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutContainer } from '@/components/molecules/Layout/LayoutContainer';
import { cn } from '@/utils/cn';
import { useEffect, useRef, useState } from 'react';
import { TransitionPaletteContext } from './TransitionPaletteContext';
export { TransitionPaletteContext };
const PALETTE_VALUES = ['none', 'palette-light', 'palette-dark', 'palette-partial', 'palette-highlight'];
const TransitionPalette = ({ children, className, active = true, palette, ...props }) => {
    const containerRef = useRef(null);
    const [activePalette, setActivePalette] = useState(palette);
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        const intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const entryPalette = entry.target.getAttribute('data-palette');
                    setActivePalette(PALETTE_VALUES.includes(entryPalette) ? entryPalette : palette);
                }
            });
        }, { rootMargin: '-25% 0px -75% 0px', threshold: 0 });
        Array.from(container.children).forEach((child) => intersectionObserver.observe(child));
        const mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node instanceof Element)
                        intersectionObserver.observe(node);
                });
                mutation.removedNodes.forEach((node) => {
                    if (node instanceof Element)
                        intersectionObserver.unobserve(node);
                });
            });
        });
        mutationObserver.observe(container, { childList: true });
        return () => {
            intersectionObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, [palette, active]);
    if (!active) {
        return (_jsx(LayoutContainer, { palette: palette, className: cn('@container col-start-1 row-span-2 row-start-1', className), ...props, children: children }));
    }
    return (_jsx(LayoutContainer, { ref: containerRef, palette: activePalette, className: cn('@container col-start-1 row-span-2 row-start-1', 'ease-macro transition duration-800', className), ...props, children: _jsx(TransitionPaletteContext.Provider, { value: true, children: children }) }));
};
export default TransitionPalette;
